var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToolbarSendIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.563 1.188a.982.982 0 01.406.968l-2 13c-.031.313-.219.563-.5.719a.96.96 0 01-.875.063l-3.719-1.563-2.156 2.313a.968.968 0 01-1.094.25C6.25 16.813 6 16.438 6 16v-2.594a.47.47 0 01.125-.344l5.219-5.718a.49.49 0 000-.688.49.49 0 00-.688 0l-6.344 5.625-2.78-1.375A.989.989 0 011 10.031c-.031-.344.156-.687.5-.875l14-8c.313-.187.75-.187 1.063.032z"
  })));
}
export default SvgToolbarSendIcon;